// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6ac93adb] .el-submenu__title{height:auto important!important;line-height:33px!important}[data-v-6ac93adb] .el-submenu__title .el-submenu__icon-arrow{display:none}", ""]);
// Exports
module.exports = exports;
